<div class="dialog-content-container">
  <div class="dialog-header mb-2">
    <img src="assets/images/shield.svg" alt="Seguridad" class="shield-icon" />
    <h3 class="dialog-title">Desactivar autenticación por dos factores</h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text mb-4">
      Ingrese el código de verificación de su dispositivo móvil
    </p>
    <form [formGroup]="form" (ngSubmit)="onConfirm()" class="w-full">
      <div class="field mb-3">
        <p-inputOtp
          id="code"
          formControlName="code"
          [length]="6"
          [integerOnly]="true"
          [autofocus]="true"
          styleClass="w-full h-3rem text-xl"
        ></p-inputOtp>
        <div
          *appFormFieldError="form.get('code'); let errors"
          class="error-message-small"
        >
          @for (error of errors; track error) {
          <div>{{ error }}</div>
          }
        </div>
      </div>
      <div class="actions">
        <button
          pButton
          type="submit"
          class="p-button-primary w-full"
          [disabled]="form.invalid || submitting"
        >
          {{ submitting ? "Desactivando..." : "Desactivar" }}
        </button>
      </div>
    </form>
  </div>
</div>
